import React from 'react'
import PropTypes from 'prop-types'

const DEFAULT_BACKGROUND_COLOR = '#CfD2D5'

export default class Avatar extends React.PureComponent {
 
  static propTypes = {
    size: PropTypes.number,
    backgroundColor: PropTypes.string,
    style: PropTypes.object,
    imageSource: PropTypes.string
  }

  render() {
    const backgroundColor = this.props.backgroundColor || DEFAULT_BACKGROUND_COLOR
    return (
      <div style={{ ...this.props.style, ...styles.container(this.props.size, backgroundColor) }}>
        <img height={this.props.size} width={this.props.size}
          src={this.props.imageSource} />
      </div>
    )
  }
  
}

const styles = {
  
  container: (size, backgroundColor) => ({
    backgroundColor,
    height: size,
    width: size,
    borderRadius: size/2
  })

}


// WEBPACK FOOTER //
// ./src/chat/ImageAvatar.js